import { connect } from 'react-redux';

import { selectUserInfo } from 'selectors/general';
import { openModal as openModalAction } from 'components/Modal';

import StaffAccountsCard from './StaffAccountsCard';

const mapStateToProps = state => ({
  user: selectUserInfo(state),
});

const mapDispatchToProps = {
  openModal: openModalAction,
};

function mergeProps(stateProps, dispatchProps, ownProps) {
  const { accountType } = ownProps;
  const { openModal, ...restDispatchProps } = dispatchProps;

  return {
    ...stateProps,
    ...restDispatchProps,
    ...ownProps,
    openModal: openModal.bind(null, 'AddStaffAccountModal', { accountType }),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(StaffAccountsCard);
